import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Incident: ITypeSpecificPolicy<types.Incident> = {
  fields: {
    createdOn: dateTimeFieldPolicy(),
    issueDate: dateTimeFieldPolicy()
  }
};
